/**
 * Auto-generated Vercel Blob Storage URLs
 * Generated by: scripts/upload-to-blob.js
 * Generated at: 2026-08-29T00:04:33.078Z
 * 
 * DO NOT EDIT MANUALLY - Re-run the upload script to regenerate
 */

// Blob store base URL (extracted from first URL)
export const BLOB_STORE_BASE_URL = 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com';

// Individual blob URLs mapped from original paths
export const BLOB_URLS: Record<string, string> = {
  '/android-chrome-192x192.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/android-chrome-192x192.png',
  '/android-chrome-192x192.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/android-chrome-192x192.svg',
  '/android-chrome-512x512.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/android-chrome-512x512.png',
  '/android-chrome-512x512.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/android-chrome-512x512.svg',
  '/apple-touch-icon.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/apple-touch-icon.png',
  '/apple-touch-icon.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/apple-touch-icon.svg',
  '/favicon-16x16.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/favicon-16x16.png',
  '/favicon-16x16.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/favicon-16x16.svg',
  '/favicon-32x32.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/favicon-32x32.png',
  '/favicon-32x32.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/favicon-32x32.svg',
  '/favicon.ico': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/favicon.ico',
  '/icon.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/icon.svg',
  '/images/fortune-cookie-banner.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/images/fortune-cookie-banner.svg',
  '/images/fortune-cookie-hero.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/images/fortune-cookie-hero.svg',
  '/images/funny-fortune-cookie-messages.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/images/funny-fortune-cookie-messages.svg',
  '/images/funny-fortune-cookie-sayings-party.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/images/funny-fortune-cookie-sayings-party.svg',
  '/images/love-fortune-cookie-messages.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/images/love-fortune-cookie-messages.svg',
  '/images/love-fortune-cookie-sayings-wedding.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/images/love-fortune-cookie-sayings-wedding.svg',
  '/logo.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/logo.svg',
  '/og-image.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/og-image.png',
  '/og-image.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/og-image.svg',
  '/twitter-image.png': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/twitter-image.png',
  '/twitter-image.svg': 'https://oxnbbm6ljoyuzqns.public.blob.vercel-storage.com/twitter-image.svg',
};

// Helper function to get blob URL for an image path
export function getBlobUrl(imagePath: string): string {
  // Normalize path to start with /
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return BLOB_URLS[normalizedPath] || imagePath;
}

// Check if an image path has a blob URL
export function hasBlobUrl(imagePath: string): boolean {
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return normalizedPath in BLOB_URLS;
}
